import script from "./NuevoEmpelado.vue?vue&type=script&setup=true&lang=js"
export * from "./NuevoEmpelado.vue?vue&type=script&setup=true&lang=js"

import "./NuevoEmpelado.vue?vue&type=style&index=0&id=f3ecdbaa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3ecdbaa"]])

export default __exports__